<div class="header bg-primary pb-6 mb-3">
    <div class="container-fluid">
        <div class="header-body">
            <div class="row align-items-center py-4">
                <div class="col-lg-12 col-12">
                    <div class="d-flex justify-content-between">
                        <h6 class="h6 fw-bold text-white d-inline-block mb-0">{{ title }}</h6>
                        <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
                            <ol class="breadcrumb breadcrumb-links breadcrumb-dark">
                                <li class="breadcrumb-item"><a class="text-decoration-none" [routerLink]="['/']">Home</a></li>
                                <li class="breadcrumb-item"><a class="text-decoration-none" [routerLink]="['/region']">
                                    <span *ngIf="(region$ | async);let region">{{ region.name }}</span>
                                </a></li>
                                <li class="breadcrumb-item active" aria-current="page">{{ title }}</li>
                            </ol>
                        </nav>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>